"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Thu Jun 28 2018
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var RequireValidator_1 = require("../../core/model/data-dictionary/validators/RequireValidator");

var Site_1 = require("./Site");
/**
 * The competitor site of competing company.
 * Competitor site can be assigned to one or more local price zones.
 * It is still part of national price zones.
 *
 * @author JMe
 * @author JMr
 * @author Radek Beran
 */


var CompetitorSite =
/*#__PURE__*/
function (_Site_1$Site) {
  _inherits(CompetitorSite, _Site_1$Site);

  /**
   * Constructs competitor site.
   *
   * @param id the internal id
   * @param externalId the external id of site, i.e. from source data
   * @param address street + sometimes number
   * @param city
   * @param companyId
   * @param type
   * @param formatId id of SiteFormat (supermarket, hypermarket, ...)
   * @param active Competitor site can be deactivated
   */
  function CompetitorSite(id, externalId, address, city, companyId, type, formatId, active) {
    var _this;

    _classCallCheck(this, CompetitorSite);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorSite).call(this, id, externalId, address, companyId, type, formatId));
    _this.id = id;
    _this.externalId = externalId;
    _this.address = address;
    _this.city = city;
    _this.companyId = companyId;
    _this.type = type;
    _this.formatId = formatId;
    _this.active = active;
    return _this;
  }

  return CompetitorSite;
}(Site_1.Site);

exports.CompetitorSite = CompetitorSite; // tslint:disable-next-line:member-ordering

CompetitorSite.schema = function () {
  var bld = new StructPropBuilder_1.StructPropBuilder(CompetitorSite.name);
  return {
    id: bld.id('id'),
    externalId: bld.str('externalId', new RequireValidator_1.RequireValidator()),
    address: bld.opt(bld.str('address', new RequireValidator_1.RequireValidator())),
    city: bld.opt(bld.str('city', new RequireValidator_1.RequireValidator())),
    companyId: bld.str('companyId'),
    type: bld.opt(bld.senum('type', Site_1.SiteType, 'enums/SiteType')),
    formatId: bld.opt(bld.str('formatId')),
    active: bld.opt(bld.bool('active'))
  };
}();